import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import styles from './label.module.scss';
var Label = function Label(props) {
  var _cx;
  var children = props.children,
    className = props.className,
    style = props.style,
    inline = props.inline,
    required = props.required,
    showMandatoryIndicator = props.showMandatoryIndicator,
    title = props.title,
    highlight = props.highlight;
  var isMandatoryIndicatorAllowed = required && showMandatoryIndicator;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(className, (_cx = {
      'd-inline': inline
    }, _defineProperty(_cx, styles.requiredLabel, isMandatoryIndicatorAllowed), _defineProperty(_cx, styles.label, !highlight), _defineProperty(_cx, styles.labelHighlight, highlight), _cx)),
    style: style,
    title: title
  }, children);
};
Label.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  inline: PropTypes.bool,
  className: PropTypes.string,
  required: PropTypes.bool,
  style: PropTypes.object,
  showMandatoryIndicator: PropTypes.bool,
  highlight: PropTypes.bool
};
Label.defaultProps = {
  title: undefined,
  children: undefined,
  inline: false,
  required: false,
  className: EMPTY_STRING,
  style: EMPTY_OBJECT,
  showMandatoryIndicator: true,
  highlight: false
};
export default Label;